import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import PopupManager from "@/components/PopupManager";
import api from "@/lib/api";

export default function PublicLayout() {
  const [horaires, setHoraires] = useState([]);
  const { pathname } = useLocation();

  const fetchShared = useCallback(async () => {
    try {
      const h = await api.get("/horaires");
      setHoraires(h.data);
    } catch {}
  }, []);

  useEffect(() => { fetchShared(); }, [fetchShared]);

  // Scroll back to top whenever the route changes
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[#FDFBF7]">
      <Navbar />
      <main className="flex-1">
        <Outlet context={{ horaires }} />
      </main>
      <Footer horaires={horaires} />
      <PopupManager />
    </div>
  );
}
